import axios from 'axios'
import router from '../router'
import { Message } from 'element-ui'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 在.env文件中配置
  timeout: 5000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 从localStorage获取token
    const token = localStorage.getItem('mobiletoken')
    if (token) {
      config.headers['MobileAuthorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    const { status } = error.response
    console.log("request err", error)
    if (status === 401) {
      // 统一处理401错误
      Message.error('登录已过期，请重新登录')
      localStorage.removeItem('mobiletoken')
      router.replace({
            path: '/mobilelogin'
        });
    } else if (status >= 500) {
      Message.error(error.response?.data.error|| '服务器错误')
    } else {
      if(status !== 400)
      {
        Message.error(error.response?.data.error|| '请求错误')
      }else{
        return Promise.reject(error.response?.data)
      }
    }
    return Promise.reject(error.response?.data)
  }
)

export default service